export enum GELayoutDirection {
    Left,
    Right,
    RightDouble
}

export enum GENodeLayering {
    NETWORK_SIMPLEX = "NETWORK_SIMPLEX",
    LONGEST_PATH = "LONGEST_PATH",
    INTERACTIVE = "INTERACTIVE"
}

export enum GENodePlacement {
    SIMPLE = "SIMPLE",
    BRANDES_KOEPF = "BRANDES_KOEPF",
    LINEAR_SEGMENTS = "LINEAR_SEGMENTS",
    INTERACTIVE = "INTERACTIVE"
}